import { useContext, useEffect, useState } from "react";
import { HistoryContainer } from "./styled";
import TableCommon from "../../../components/Common/TableCommon";
import { ContextProviderWrapper } from "../../../components/Context";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { shortenAddress } from "../../../utils/addressUser";
import { CopyOutlined } from "@ant-design/icons";
import { AVAX_API } from "../../../services/api/indexV2";
import moment from "moment";
import { Link } from "react-router-dom";
import {
  BlockAddress,
  ContentTableMobile,
} from "../../Avax/Leaderboard/styled";

export interface TransactionItem {
  id: string;
  createdAt: string;
  updatedAt: string;
  version: number;
  address: string;
  router_address: string;
  tx_hash: string;
  src_address: string;
  dest_address: string;
  src_amount: number;
  src_usd: number;
  dest_amount: number;
  gas: number | null;
  gas_usd: number;
  is_success: boolean;
  aggregator_id: string;
  status: string;
  chain_id: number;
}

export interface TransactionResponse {
  data: TransactionItem[];
  count: number;
}

export const History = () => {
  const { theme, isMobile } = useContext(ContextProviderWrapper)!;
  const [dataTx, setDataTx] = useState<TransactionResponse | null>();
  const handleChangeType = (type: any) => {
    switch (type) {
      case "Single_chain":
        return "Single Chain";
      default:
        return "--";
    }
  };
  const handleChangeLink = (chain: any, hash: any) => {
    switch (chain) {
      case 43114:
        return `https://snowscan.xyz/tx/${hash}`;
      case 396:
        return `https://tonscan.org/tx/${hash}`;
      case 101:
        return `https://solscan.io/tx/${hash}`;
    }
  };
  const headingData = !isMobile
    ? [
        {
          name: `Time`,
          dataIndex: "createdAt",
          key: "createdAt",
          render: (data: any) => {
            return <p>{moment(data).format("MMMM DD HH:mm")}</p>;
          },
        },
        {
          name: `Address`,
          dataIndex: "address",
          key: "address",
          render: (data: any) => {
            return (
              <BlockAddress>
                <CopyToClipboard
                  text={`${data}`}
                  onCopy={() => {
                    toast.success("Copied !!");
                  }}
                >
                  <div className={`copy-inner ${theme}`}>
                    <p>{shortenAddress(data)}</p>
                    <CopyOutlined />
                  </div>
                </CopyToClipboard>
              </BlockAddress>
            );
          },
        },
        {
          name: `Amount`,
          dataIndex: "src_amount",
          key: "src_amount",
          render: (data: any) => {
            return <p>{data?.toFixed(4)}</p>;
          },
        },
        {
          name: `Hash`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return (
              <BlockAddress>
                <Link
                  to={`${handleChangeLink(data.chain_id, data.tx_hash)}`}
                  target="_blank"
                >
                  <div className={`copy-inner ${theme}`}>
                    <p>{shortenAddress(data.tx_hash)}</p>
                  </div>
                </Link>
              </BlockAddress>
            );
          },
        },
        {
          name: `Gas`,
          dataIndex: "gas_usd",
          key: "gas_usd",
          render: (data: any) => {
            return <p>${data?.toFixed(4)}</p>;
          },
        },
        {
          name: `Type`,
          dataIndex: "type",
          key: "type",
          render: (data: any) => {
            return <p>{handleChangeType(data)}</p>;
          },
        },
        {
          name: `Status`,
          dataIndex: "status",
          key: "status",
          render: (data: any) => {
            return (
              <span
                className={`tag ${theme} ${
                  data === "Succeed" ? "is-success" : ""
                }`}
              >
                {data}
              </span>
            );
          },
        },
      ]
    : [
        {
          name: `Transaction`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return (
              <ContentTableMobile className={theme}>
                {/* <div className="rank">{data.rank}</div> */}
                <div className="content-right">
                  <div className="block-address">
                    <p className="address">
                      <CopyToClipboard
                        text={`${data?.address}`}
                        onCopy={() => {
                          toast.success("Copied !!");
                        }}
                      >
                        <div
                          className="copy-inner"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <p>{shortenAddress(data?.address)}</p>
                          <CopyOutlined />
                        </div>
                      </CopyToClipboard>
                    </p>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        Dest Address:{" "}
                        <span>{shortenAddress(data.dest_address)}</span>
                      </p>
                    </div>
                    <div className="transaction-inner">
                      <p>
                        Dest Amount: <span>{data.dest_amount?.toFixed(4)}</span>
                      </p>
                    </div>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        From Address:{" "}
                        <span>{shortenAddress(data.src_address)}</span>
                      </p>
                    </div>
                    <div className="transaction-inner">
                      <p>
                        Dest Amount: <span>{data.src_amount?.toFixed(4)}</span>
                      </p>
                    </div>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        Txn
                        <span>
                          <Link
                            to={`${handleChangeLink(
                              data.chain_id,
                              data.tx_hash
                            )}`}
                            target="_blank"
                          >
                            <div className="copy-inner">
                              <p>{shortenAddress(data?.tx_hash)}</p>
                            </div>
                          </Link>
                        </span>
                      </p>
                    </div>
                    <div className="transaction-inner">
                      <p>
                        Status: <span>{data.status}</span>
                      </p>
                    </div>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        Type:
                        <span>{handleChangeType(data.type)}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </ContentTableMobile>
            );
          },
        },
      ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await AVAX_API.getTx();
        setDataTx(res?.data);
      } catch (err) {
        console.error("Failed to fetch tx:", err);
      }
    };

    fetchData();
  }, []);

  const moveToDetail = "leaderboard";
  return (
    <HistoryContainer>
      <TableCommon
        data={dataTx?.data}
        heading={headingData}
        moveTo={moveToDetail}
        pagination={dataTx && dataTx?.data?.length > 10 ? true : false}
      />
    </HistoryContainer>
  );
};

export default History;
